/* ==========================================================================
   Silwer Theme — Global JS
   AJAX cart: add-to-cart interception, slide-out cart drawer, live count.
   Uses Shopify's default Cart AJAX API (/cart/add.js, /cart/change.js, /cart.js).
   (When GoKwik is installed later, its drawer/checkout can replace this layer.)
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Money (Indian ₹, whole rupees, lakh/crore grouping) ---------- */
  function formatINR(cents) {
    var rupees = Math.round((cents || 0) / 100);
    try {
      return '₹' + new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(rupees);
    } catch (e) {
      return '₹' + rupees;
    }
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (width || 160);
  }

  /* ------------------------------- Elements -------------------------------- */
  var drawer, itemsEl, footerEl, emptyEl, subtotalEl;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function cacheEls() {
    drawer = qs('#cart-drawer');
    itemsEl = qs('[data-cart-items]');
    footerEl = qs('[data-cart-footer]');
    emptyEl = qs('[data-cart-empty]');
    subtotalEl = qs('[data-cart-subtotal]');
  }

  /* ----------------------------- Count badges ------------------------------ */
  function updateCounts(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      // Header badge: hide when empty
      if (el.hasAttribute('data-cart-count-badge')) {
        el.style.display = count > 0 ? '' : 'none';
      }
    });
  }

  /* --------------------------- Drawer open/close --------------------------- */
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ------------------------------ Rendering -------------------------------- */
  function render(cart) {
    updateCounts(cart.item_count);
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (footerEl) footerEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatINR(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var opts = (item.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.name + ': ' + o.value; })
        .join(' &middot; ');

      var line = item.line || cart.items.indexOf(item) + 1;
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;

      return '' +
        '<div class="cart-line" data-line="' + line + '">' +
          '<a href="' + item.url + '" class="cart-line__img">' +
            (img ? '<img src="' + sizedImage(img, 160) + '" alt="' + (item.title || '') + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="cart-line__info">' +
            '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
            (opts ? '<p class="cart-line__opts">' + opts + '</p>' : '') +
            '<div class="cart-line__row">' +
              '<div class="cart-qty" data-line="' + line + '">' +
                '<button type="button" class="cart-qty__btn" data-qty-down aria-label="Decrease quantity">&minus;</button>' +
                '<span class="cart-qty__val">' + item.quantity + '</span>' +
                '<button type="button" class="cart-qty__btn" data-qty-up aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cart-line__price">' + formatINR(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove="' + line + '">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  /* ------------------------------- Cart API -------------------------------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    return getCart().then(render).catch(function (e) { console.error('[cart] refresh', e); });
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"], [name="add"]');
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('is-loading'); }

    var data = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;
          return body;
        });
      })
      .then(function () { return refresh(); })
      .then(function () { openCart(); })
      .catch(function (err) {
        console.error('[cart] add', err);
        var msg = (err && err.description) ? err.description : 'Sorry, this item could not be added.';
        window.alert(msg);
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); if (original !== null) btn.innerHTML = original; }
      });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (e) { console.error('[cart] change', e); });
  }

  /* ------------------------------- Bindings -------------------------------- */
  function bind() {
    // Intercept every product add-to-cart form (PDP + sticky bar submit through it)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.getAttribute && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        e.preventDefault();
        addToCart(form);
      }
    });

    // Open drawer from header cart button (fallback link still works if JS off)
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest ? e.target.closest('[data-cart-toggle]') : null;
      if (toggle) { e.preventDefault(); openCart(); refresh(); return; }

      var close = e.target.closest ? e.target.closest('[data-cart-close]') : null;
      if (close) { e.preventDefault(); closeCart(); return; }

      // Quantity + remove inside the drawer
      var down = e.target.closest ? e.target.closest('[data-qty-down]') : null;
      var up = e.target.closest ? e.target.closest('[data-qty-up]') : null;
      var rem = e.target.closest ? e.target.closest('[data-line-remove]') : null;

      if (down || up) {
        var wrap = (down || up).closest('.cart-qty');
        var line = parseInt(wrap.getAttribute('data-line'), 10);
        var cur = parseInt(wrap.querySelector('.cart-qty__val').textContent, 10) || 1;
        changeLine(line, up ? cur + 1 : Math.max(0, cur - 1));
      }
      if (rem) {
        changeLine(parseInt(rem.getAttribute('data-line-remove'), 10), 0);
      }
    });

    // Esc closes the drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    cacheEls();
    bind();
    // Sync count on load (in case badge markup was cached)
    getCart().then(function (cart) { updateCounts(cart.item_count); }).catch(function () {});
  });
})();
